import { render, staticRenderFns } from "./NotificationPermissionPrompt.vue?vue&type=template&id=38479376&scoped=true&"
import script from "./NotificationPermissionPrompt.vue?vue&type=script&lang=js&"
export * from "./NotificationPermissionPrompt.vue?vue&type=script&lang=js&"
import style0 from "./NotificationPermissionPrompt.vue?vue&type=style&index=0&id=38479376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38479376",
  null
  
)

export default component.exports